/* Selected Wallpapers — variant-picker (extern gemaakt 14-09-2026, was inline; laadt 1x per pagina, cache) */
(function(){
  if (window.__swVariantPickerAsset) return; window.__swVariantPickerAsset = 1;
function swCfgAll(name){ return Array.prototype.slice.call(document.querySelectorAll('script[data-sw-cfg="' + name + '"]')); }
function swCfgParse(el){ try { return JSON.parse(el.textContent || '{}'); } catch(e){ return {}; } }
function swVariants(sectionId, fallback){ var el = sectionId ? document.getElementById('VariantData-' + sectionId) : null; if (el) { try { var v = JSON.parse(el.textContent || '[]'); if (Array.isArray(v)) return v; } catch(e){} } return Array.isArray(fallback) ? fallback : []; }
function swReady(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function init(cfg){

      var rootId = 'variant-selects-' + cfg.sectionId; var sec = cfg.sectionId;
      var formId = cfg.formId;
      var canUpdateUrl = cfg.updateUrl !== false;
      var booted = false;

      function cssEscape(str){
        str = String(str == null ? '' : str);
        if (window.CSS && window.CSS.escape) return window.CSS.escape(str);
        return str.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
      }

      function findRoot(){
        return document.getElementById(rootId);
      }

      function findForm(){
        var form = document.getElementById(formId);
        if (form) return form;
        try {
          form = document.querySelector('form#' + cssEscape(formId));
          if (form) return form;
        } catch(e) {}
        var root = findRoot();
        if (!root) return null;
        var info = document.getElementById('ProductInfo-' + sec) || root.closest('product-info') || root.parentNode;
        if (info && info.querySelector) {
          form = info.querySelector('form[action*="/cart/add"]');
          if (form) return form;
        }
        return document.querySelector('form[action*="/cart/add"]');
      }

      function parseVariants(root){
        var jsonEl = root ? root.querySelector('#variants' + sec) : null;
        if (!jsonEl) jsonEl = document.getElementById('variants' + sec);
        if (!jsonEl) return [];
        try { return JSON.parse(jsonEl.textContent || '[]') || []; } catch(e) { return []; }
      }

      function getOptionBlocks(root){
        return Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
      }

      function getOptionValue(variant, index){
        return variant ? variant['option' + (index + 1)] : '';
      }

      function readSelections(blocks){
        var out = [];
        for (var i = 0; i < blocks.length; i++) {
          var block = blocks[i];
          var select = block.querySelector('select');
          if (select) {
            out.push(String(select.value || ''));
            continue;
          }
          var checked = block.querySelector('input[type="radio"]:checked');
          out.push(checked ? String(checked.value || '') : '');
        }
        return out;
      }

      function findVariantById(variants, id){
        id = String(id || '');
        if (!id) return null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === id) return variants[i];
        }
        return null;
      }

      function getCurrentHiddenVariant(form, variants){
        if (!form) return null;
        var idInput = form.querySelector('input[name="id"]');
        return idInput ? findVariantById(variants, idInput.value) : null;
      }

      function matchesSelections(variant, selections){
        for (var i = 0; i < selections.length; i++) {
          if (selections[i] && getOptionValue(variant, i) !== selections[i]) return false;
        }
        return true;
      }

      function findExactVariant(variants, selections){
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < selections.length; j++) {
            if (String(getOptionValue(variants[i], j) || '') !== String(selections[j] || '')) {
              ok = false;
              break;
            }
          }
          if (ok) return variants[i];
        }
        return null;
      }

      function pickBestVariant(variants, selections, changedIndex, currentVariant){
        var best = null;
        var bestScore = -999999;

        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var score = 0;
          var rejected = false;

          if (typeof changedIndex === 'number' && selections[changedIndex]) {
            if (String(getOptionValue(v, changedIndex) || '') !== String(selections[changedIndex])) {
              continue;
            }
            score += 1000;
          }

          for (var j = 0; j < selections.length; j++) {
            var wanted = String(selections[j] || '');
            if (!wanted) continue;
            var actual = String(getOptionValue(v, j) || '');
            if (actual === wanted) {
              score += (j === changedIndex ? 100 : 25);
            } else if (typeof changedIndex !== 'number') {
              score -= 2;
            }
          }

          if (currentVariant && String(currentVariant.id) === String(v.id)) score += 3;
          if (v.available) score += 1;

          if (!rejected && score > bestScore) {
            best = v;
            bestScore = score;
          }
        }

        if (best) return best;

        for (var k = 0; k < variants.length; k++) {
          if (variants[k].available) return variants[k];
        }
        return variants.length ? variants[0] : null;
      }

      function getChoiceContainer(block, input){
        var label = null;
        if (input.id) {
          try {
            label = block.querySelector('label[for="' + cssEscape(input.id) + '"]');
          } catch(e) {}
        }
        var node = label || input;
        while (node && node !== block) {
          if (
            node.tagName === 'LABEL' ||
            (node.classList && (
              node.classList.contains('swatch-element') ||
              node.classList.contains('swatch') ||
              node.classList.contains('variant-option') ||
              node.classList.contains('vswatch') ||
              node.classList.contains('opt-item')
            ))
          ) {
            return node;
          }
          node = node.parentElement;
        }
        return label || input.parentElement || input;
      }

      function setChoiceAvailability(block, value, enabled){
        var radios = block.querySelectorAll('input[type="radio"]');
        if (!radios.length) return;

        for (var i = 0; i < radios.length; i++) {
          var input = radios[i];
          if (String(input.value || '') !== String(value || '')) continue;
          input.disabled = !enabled;
          input.setAttribute('aria-disabled', enabled ? 'false' : 'true');

          var container = getChoiceContainer(block, input);
          if (container) {
            container.setAttribute('data-swv-disabled', enabled ? 'false' : 'true');
            container.classList.toggle('swv-disabled', !enabled);
            if (!enabled) {
              container.setAttribute('aria-disabled', 'true');
            } else {
              container.removeAttribute('aria-disabled');
            }
          }
        }
      }

      function variantMatchesPrefix(variant, selections, uptoIndex){
        for (var i = 0; i < uptoIndex; i++) {
          var wanted = String(selections[i] || '');
          if (!wanted) continue;
          if (String(getOptionValue(variant, i) || '') !== wanted) return false;
        }
        return true;
      }

      function setSelectAvailability(block, currentSelections, variants, optionIndex){
        var select = block.querySelector('select');
        if (!select) return;

        for (var i = 0; i < select.options.length; i++) {
          var opt = select.options[i];
          var value = String(opt.value || '');
          if (!value) continue;

          var enabled = false;
          for (var j = 0; j < variants.length; j++) {
            var v = variants[j];
            if (!variantMatchesPrefix(v, currentSelections, optionIndex)) continue;
            if (String(getOptionValue(v, optionIndex) || '') !== value) continue;
            enabled = true;
            break;
          }
          opt.disabled = !enabled;
        }
      }

      function updateAvailability(blocks, variants, resolvedSelections){
        for (var i = 0; i < blocks.length; i++) {
          var block = blocks[i];
          var select = block.querySelector('select');
          if (select) {
            setSelectAvailability(block, resolvedSelections, variants, i);
            continue;
          }

          var radios = block.querySelectorAll('input[type="radio"]');
          var seen = {};
          for (var r = 0; r < radios.length; r++) {
            var value = String(radios[r].value || '');
            if (seen[value]) continue;
            seen[value] = true;

            var enabled = false;
            for (var vIndex = 0; vIndex < variants.length; vIndex++) {
              var v = variants[vIndex];
              if (!variantMatchesPrefix(v, resolvedSelections, i)) continue;
              if (String(getOptionValue(v, i) || '') !== value) continue;
              enabled = true;
              break;
            }
            setChoiceAvailability(block, value, enabled);
          }
        }
      }

      function syncHeaders(blocks, selections){
        for (var i = 0; i < blocks.length; i++) {
          var headerValue = blocks[i].querySelector('[data-opt]');
          if (headerValue) headerValue.textContent = selections[i] || '';
        }
      }

      function setControlsToVariant(blocks, variant){
        var changed = false;
        var lastChangedEl = null;

        for (var i = 0; i < blocks.length; i++) {
          var targetValue = String(getOptionValue(variant, i) || '');
          var block = blocks[i];
          var select = block.querySelector('select');
          if (select) {
            if (String(select.value || '') !== targetValue) {
              select.value = targetValue;
              changed = true;
              lastChangedEl = select;
            }
            continue;
          }

          var radios = block.querySelectorAll('input[type="radio"]');
          for (var r = 0; r < radios.length; r++) {
            if (String(radios[r].value || '') === targetValue) {
              if (!radios[r].checked) {
                radios[r].checked = true;
                changed = true;
                lastChangedEl = radios[r];
              }
              break;
            }
          }
        }

        return { changed: changed, lastChangedEl: lastChangedEl };
      }

      function updateHiddenVariant(form, variant){
        if (!form || !variant) return false;
        var idInput = form.querySelector('input[name="id"]');
        if (!idInput) return false;
        var next = String(variant.id || '');
        var prev = String(idInput.value || '');
        if (prev === next) return false;
        idInput.value = next;
        idInput.setAttribute('value', next);
        return true;
      }

      function notifyTheme(root, form, variant, changedEl, shouldNotify){
        if (!shouldNotify) return;

        var idInput = form ? form.querySelector('input[name="id"]') : null;
        if (idInput) {
          idInput.dispatchEvent(new Event('input', { bubbles: true }));
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (changedEl) {
          changedEl.dispatchEvent(new Event('input', { bubbles: true }));
          changedEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var payload = { variant: variant, sectionId: sec };
        document.dispatchEvent(new CustomEvent('variant:change', { detail: payload, bubbles: true }));
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: payload, bubbles: true }));

        if (canUpdateUrl && variant && history && history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', String(variant.id));
            history.replaceState({}, '', url.toString());
          } catch(e) {}
        }
      }

      function init(root, form, variants){
        var syncing = false;
        var hiddenObserver = null;

        function reconcile(changedIndex){
          if (syncing) return;
          var blocks = getOptionBlocks(root);
          if (!blocks.length) return;

          var selections = readSelections(blocks);
          var currentVariant = getCurrentHiddenVariant(form, variants);
          var exact = findExactVariant(variants, selections);
          var resolved = exact || pickBestVariant(variants, selections, changedIndex, currentVariant);
          if (!resolved) return;

          syncing = true;

          var controlResult = setControlsToVariant(blocks, resolved);
          var resolvedSelections = [];
          for (var i = 0; i < blocks.length; i++) {
            resolvedSelections.push(String(getOptionValue(resolved, i) || ''));
          }

          syncHeaders(blocks, resolvedSelections);
          updateAvailability(blocks, variants, resolvedSelections);

          var idChanged = updateHiddenVariant(form, resolved);
          var needsNotify = controlResult.changed || idChanged;

          syncing = false;
          notifyTheme(root, form, resolved, controlResult.lastChangedEl, needsNotify);
        }

        root.addEventListener('change', function(evt){
          var target = evt.target;
          if (!target) return;
          if (!target.matches('select, input[type="radio"]')) return;
          if (syncing) return;
          var block = target.closest('[data-option-index]');
          var changedIndex = block ? parseInt(block.getAttribute('data-option-index'), 10) : null;
          window.setTimeout(function(){ reconcile(isNaN(changedIndex) ? null : changedIndex); }, 0);
        }, true);

        root.addEventListener('click', function(evt){
          var disabledWrap = evt.target.closest('[data-swv-disabled="true"]');
          if (disabledWrap && root.contains(disabledWrap)) {
            evt.preventDefault();
            evt.stopPropagation();
          }
        }, true);

        var idInput = form ? form.querySelector('input[name="id"]') : null;
        if (idInput && window.MutationObserver) {
          hiddenObserver = new MutationObserver(function(){
            if (syncing) return;
            window.setTimeout(function(){ reconcile(null); }, 0);
          });
          hiddenObserver.observe(idInput, { attributes: true, attributeFilter: ['value'] });
          idInput.addEventListener('change', function(){ if (!syncing) window.setTimeout(function(){ reconcile(null); }, 0); });
          idInput.addEventListener('input', function(){ if (!syncing) window.setTimeout(function(){ reconcile(null); }, 0); });
        }

        document.addEventListener('variant:change', function(){ if (!syncing) window.setTimeout(function(){ reconcile(null); }, 0); });
        document.addEventListener('variant:changed', function(){ if (!syncing) window.setTimeout(function(){ reconcile(null); }, 0); });

        reconcile(null);
      }

      function boot(){
        if (booted) return;
        var root = findRoot();
        if (!root) return;
        var form = findForm();
        var variants = parseVariants(root);

        if (!form || !variants.length) {
          window.setTimeout(boot, 60);
          return;
        }

        booted = true;
        init(root, form, variants);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      }
      window.setTimeout(boot, 0);
      window.setTimeout(boot, 120);
      document.addEventListener('shopify:section:load', boot);
    
  }
  function boot(){ swCfgAll('variant-picker').forEach(function(el){ if (el.__swDone) return; el.__swDone = 1; try { init(swCfgParse(el)); } catch(e){ if (window.console) console.error('variant-picker', e); } }); }
  swReady(boot);
  document.addEventListener('shopify:section:load', boot);
})();
